/* global requirejs */
define(function (require) {
	const Marionette = require('backbone.marionette');
	const tpl = require('./t_v_agencymap.hbs');
	const AgencyMapModel = require('civicsModels/agencymap_model');
	const ViewManager = require('civicsUtils/view_manager');
	const LiveRegion = require('civicsUtils/live_region_utility');

	return Marionette.LayoutView.extend({
		initialize: function (options) {
			this.config = [];
			this.regionId = options.config.regionId != null ? options.config.regionId + ' gis-map-region': 'gis-map-region';
			this.config.globalConfig = ViewManager.globalConfig();

			this.mapReady = false;//used to determine what to do for destroying this view
			// nothing to do?
			var self = this;
			let radio = options.config.channel;
			if ( radio ){
				radio.on('map:ready', info => {
					self.ui.mapLoader.hide();

					if( __DEV__ ) console.log('map:ready', info);
					self.mapReady = true;
					self.addMapButtonAriaLabels();
				});
			}
		},
		ui:{
			mapLoader: '.map-loading-indicator',
		},
		addMapButtonAriaLabels: function () {
			var $el = this.$el;
			if (!$el || !$el.length) return;

			// Delay slightly to ensure map controls are fully rendered
			setTimeout(function() {
				var $zoomIn = $el.find('.zoom-in-tool button');
				var $zoomOut = $el.find('.zoom-out-tool button');
				var $locateMe = $el.find('.locate-me button');
				var $layerSwitcher = $el.find('.layer-switcher > button');

				if ($zoomIn.length) $zoomIn.attr('aria-label', i18n.t('CIVICS.COMMON.MAP_ZOOM_IN'));
				if ($zoomOut.length) $zoomOut.attr('aria-label', i18n.t('CIVICS.COMMON.MAP_ZOOM_OUT'));
				if ($locateMe.length) $locateMe.attr('aria-label', i18n.t('CIVICS.COMMON.MAP_CURRENT_LOCATION'));
				if ($layerSwitcher.length) $layerSwitcher.attr('aria-label', i18n.t('CIVICS.COMMON.MAP_LAYERS'));

				// A11y: announce zoom actions via live region
				if ($zoomIn.length) {
					$zoomIn.on('click.a11y', function() {
						LiveRegion.announcePolite(i18n.t('CIVICS.COMMON.MAP_ZOOM_IN'));
					});
				}
				if ($zoomOut.length) {
					$zoomOut.on('click.a11y', function() {
						LiveRegion.announcePolite(i18n.t('CIVICS.COMMON.MAP_ZOOM_OUT'));
					});
				}

				// Layers panel - add dialog role
				var $layersPanel = $el.find('.layer-switcher div.panel');
				if ($layersPanel.length) {
					$layersPanel.attr('role', 'dialog');
					$layersPanel.attr('aria-label', i18n.t('CIVICS.COMMON.MAP_LAYERS'));
				}
			}, 500);
		},
		onShow: function () {
			// nothing to do when attached to the dom?
		},
		onBeforeDestroy: function () {
			// be explicit about killing the maplet
			var self = this;
			let radio = this.options.config.channel;
			if ( radio ){
				if (!this.mapReady) {
					radio.on('map:ready', info => {
						radio.off('map:ready');
						radio.trigger("map:destroy");
						$(document).find("." + self.regionId).children().remove();
					});
				}
				else{
					radio.off('map:ready');
					radio.trigger("map:destroy");
				}
			}
		},

		onRender: function () {

			// Get rid of that pesky wrapping-div.
			// Assumes 1 child element present in template.
			this.$el = this.$el.children();
			// Unwrap the element to prevent infinitely
			// nesting elements during re-render.
			this.$el.unwrap();
			this.setElement(this.$el);

			let agencyMapModel = new AgencyMapModel();
			let config = this.options["config"];
			let mapConfig = config.mapConfig;
			agencyMapModel.urlRoot += "/" + mapConfig;
			let d = new $.Deferred();
			agencyMapModel.fetch({
				error: function (model, response, options) {
					ViewManager.errorToWindow(response, this);
				}
			}).then(data => {
				d.then(Loader => {
					// provides rhythm REST endpoint for data/services
					let href = agencyMapModel.urlRoot.substring(0, agencyMapModel.urlRoot.length - ("/property/agencymaps/" + mapConfig).length);
					Loader({
						view: this,
						config: data.data,
						services: href,
						selectedLayers:this.options["layerList"],
						container: this.ui.gisMap 	//this.$el.find(".gis-map-region")//container seems to have no effect
					});
				})
			});


			// TODO: ideally liferay-portal will load requirejs from CDN, loader already configured with "portal-gis" package
			if (!window["requirejs"]) {
				console.error("require.js must be added to page.jsp");
			} else {
				//temporary try catch until we get a real fix from Liferay
				try {
					requirejs(['liferay'], (Loader) => {
						d.resolve(Loader);
					});
				} catch (error) {
					d.resolve(()=>{console.warn('Error loading Rhythm GIS')});
					this.options?.config?.channel?.trigger('map:adminfailure');

				}
					

			}
		},

		css: {'height': '100%'},

		template: tpl,

		tagName: 'div',

		className: 'agency-map-view',

		modelEvents: {
			change: 'render'
		},

		regions: {
			gisMap: '.gis-map-region'
		},

		templateHelpers: function () {
			var globalConfig = this.config.globalConfig;
			return {
				Maplet: this.getOption('config').mapConfig,
				regionId: this.regionId,
				useLargeMapButtons: globalConfig.get('gis') ? globalConfig.get('gis').get('useLargeMapButtons') : false
			};
		}

	});
});
